<div class="vodafone-profile-validator"
     [ngClass]="validatorClasses()"
     fxLayout="row wrap"
     fxLayoutAlign="space-between start"
     fxLayoutGap="10px">

    <!--        -->
    <div class="vodafone-profile-info" fxFlex="35" fxFlex.xs="100" flexLayout="column">

        <!-- Image-->
        <div class="profile-name">
            <h3>{{profile.profileName}}</h3>
        </div>

        <!--            -->
        <div class="profile-image">
            <img [src]="validationImage"
                 *ngIf="isImageVisible() else noImage"
                 alt="Vodafone profile image">
        </div>

        <ng-template #noImage>
            <p>No Image</p>
        </ng-template>

    </div>

    <div class="vodafone-profile-form-section" fxFlex="61" fxFlex.sm="100" fxLayoutAlign="center center">
        <form class="vodafone-profile-form"
              [formGroup]="validationFormGroup"
              fxLayout="row" fxLayoutGap="10px">

            <ng-container formArrayName="validationFields">


                <!--                -->
                <div class="form-group" fxFlex="48" fxFlex.xs="100"
                     *ngFor="let group of validationFields?.controls ;let i=index ">

                    <ng-container dynamicField
                                  [fields]="validationFieldConfigs"
                                  [group]="group"></ng-container>
                </div>

            </ng-container>

            <!--       Submit Button             -->
<!--            <div class="validate-btn">-->
<!--                <button mat-flat-button-->
<!--                        type="button"-->
<!--                        (click)="onValidateProfile()"-->
<!--                        [color]="isDiscountApplied ? 'warn':'primary'">-->
<!--                    {{(isDiscountApplied ? 'shared.labels.discountApplied' : 'shared.labels.apply')|translate}}-->
<!--                </button>-->
<!--            </div>-->

        </form>
    </div>
</div>



